module.exports = __webpack_public_path__ + "static/media/no_plan.0fc1d1b6.png";